/*
 * @Author: LiuMeiYu
 * @Date: 2022-03-03 17:09:34
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-03-23 16:33:32
 * @FilePath: \nivara\src\api\chat.js
 * @Description: *
 * *
 * Copyright (c) 2022 by yihua, All Rights Reserved.
 */
import $http from "../http/chat"
// import qs from "qs"
// import md5 from "js-md5";

// 创建聊天
export const createChatRoomApi = (data) => {
    return $http({
        url: "/api/v1/talk/create",
        method: "post",
        data: {
            ...data
        },
    })
}
// 获取聊天列表
export const getChatListApi = (params) => {
    return $http({
        url: "/api/v1/talk/list",
        method: "get",
        params: {
            ...params
        },
    })
}
// 获取聊天记录
export const getChatRecordApi = (params) => {
    return $http({
        url: "/api/v1/talk/records",
        method: "get",
        params: {
            ...params
        },
    })
}
// 获取交易统计
export const getTradingStatisticsApi = (params) => {
    return $http({
        url: "/api/v1/talk/records/stats",
        method: "get",
        params: {
            ...params
        },
    })
}
// 发送文本消息
export const sendTextMsgApi = (data) => {
    return $http({
        url: "/api/v1/talk/message/text",
        method: "post",
        data: {
            ...data
        },
    })
}
// 发送图片消息
export const sendImageMsgApi = (data) => {
    return $http({
        url: "/api/v1/talk/message/image",
        method: "post",
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-Requested-With': 'XMLHttpRequest'
        },
        data: {
            ...data
        },
    })
}
// 删除聊天列表
export const deleteChatItemApi = (data) => {
    return $http({
        url: "/api/v1/talk/delete",
        method: "post",
        data: {
            ...data
        },
    })
}
// 置顶对话列表
export const topChatItemApi = (data) => {
    return $http({
        url: "/api/v1/talk/topping",
        method: "post",
        data: {
            ...data
        },
    })
}
// 消息免打扰
export const disturbChatItemApi = (data) => {
    return $http({
        url: "/api/v1/talk/disturb",
        method: "post",
        data: {
            ...data
        },
    })
}
// 清除未读数
export const clearUnreadMsgApi = (data) => {
    return $http({
        url: "/api/v1/talk/unread/clear",
        method: "post",
        data: {
            ...data
        },
    })
}